var _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147,
    height: 44,
    fill: "none",
    viewBox: "0 0 147 44",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#509a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M141.429 43.728H5.571c-2.99 0-5.435-2.444-5.435-5.432V5.704C.136 2.716 2.582.27 5.571.27h135.858c2.988 0 5.434 2.445 5.434 5.433v32.592c0 2.988-2.446 5.432-5.434 5.432"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6A6A6",
    d: "M141.429.272H5.571C2.58.272.136 2.716.136 5.704v32.593c0 2.987 2.446 5.432 5.435 5.432h135.858c2.988 0 5.434-2.445 5.434-5.432V5.704c0-2.988-2.446-5.432-5.434-5.432m0 .87a4.57 4.57 0 0 1 4.564 4.562v32.593a4.57 4.57 0 0 1-4.564 4.563H5.571a4.57 4.57 0 0 1-4.565-4.563V5.704A4.57 4.57 0 0 1 5.57 1.141z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.674 11.4q0 1.365-.81 2.176-.921.965-2.396.965-1.413 0-2.4-.979-.989-.978-.987-2.426-.001-1.448.988-2.427.986-.978 2.4-.979.7 0 1.337.274.638.274 1.02.728l-.573.574q-.647-.773-1.785-.774a2.48 2.48 0 0 0-1.78.724q-.753.724-.752 1.88 0 1.155.751 1.88a2.48 2.48 0 0 0 1.781.723q1.092 0 1.822-.728.473-.473.546-1.32h-2.368v-.783h3.16q.046.256.046.492"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.267,
    d: "M51.674 11.4q0 1.365-.81 2.176-.921.965-2.396.965-1.413 0-2.4-.979-.989-.978-.987-2.426-.001-1.448.988-2.427.986-.978 2.4-.979.7 0 1.337.274.638.274 1.02.728l-.573.574q-.647-.773-1.785-.774a2.48 2.48 0 0 0-1.78.724q-.753.724-.752 1.88 0 1.155.751 1.88a2.48 2.48 0 0 0 1.781.723q1.092 0 1.822-.728.473-.473.546-1.32h-2.368v-.783h3.16q.046.256.046.492Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.684 8.677h-2.97v2.067h2.678v.783h-2.678v2.067h2.97v.801h-3.808V7.877h3.808z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.267,
    d: "M56.684 8.677h-2.97v2.067h2.678v.783h-2.678v2.067h2.97v.801h-3.808V7.877h3.808z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60.217 14.395h-.838V8.677h-1.822v-.8h4.481v.8h-1.821z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.267,
    d: "M60.217 14.395h-.838V8.677h-1.822v-.8h4.481v.8h-1.821z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.267,
    d: "M65.281 7.877h.838v6.518h-.838z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M69.836 14.395h-.838V8.677h-1.822v-.8h4.481v.8h-1.821z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.267,
    d: "M69.836 14.395h-.838V8.677h-1.822v-.8h4.481v.8h-1.821z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M75.978 13.007a2.4 2.4 0 0 0 1.771.732q1.05 0 1.772-.732.724-.733.725-1.87-.001-1.14-.725-1.872a2.4 2.4 0 0 0-1.772-.733q-1.048 0-1.771.733-.724.733-.724 1.871t.724 1.871m4.162.545q-.961.99-2.39.989-1.43 0-2.39-.989-.963-.987-.962-2.416 0-1.43.961-2.417.96-.988 2.39-.989 1.421 0 2.387.993.965.993.965 2.413 0 1.43-.96 2.416"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.267,
    d: "M75.978 13.007a2.4 2.4 0 0 0 1.771.732q1.05 0 1.772-.732.724-.733.725-1.87-.001-1.14-.725-1.872a2.4 2.4 0 0 0-1.772-.733q-1.048 0-1.771.733-.724.733-.724 1.871t.724 1.871Zm4.162.545q-.961.99-2.39.989-1.43 0-2.39-.989-.963-.987-.962-2.416 0-1.43.961-2.417.96-.988 2.39-.989 1.421 0 2.387.993.965.993.965 2.413 0 1.43-.96 2.416Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M82.277 14.395V7.877h1.02l3.169 5.07h.037l-.037-1.256V7.876h.839v6.519h-.875l-3.316-5.317h-.036l.036 1.257v4.06z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.267,
    d: "M82.277 14.395V7.877h1.02l3.169 5.07h.037l-.037-1.256V7.876h.839v6.519h-.875l-3.316-5.317h-.036l.036 1.257v4.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M116.361 32.864h2.028V19.283h-2.028zm18.267-8.689-2.325 5.888h-.069l-2.413-5.888h-2.185l3.618 8.23-2.061 4.578h2.114l5.576-12.808zm-11.501 7.147c-.665 0-1.591-.332-1.591-1.154 0-1.048 1.153-1.45 2.149-1.45.892 0 1.312.193 1.854.455a2.46 2.46 0 0 1-2.412 2.149m.244-7.443c-1.468 0-2.99.646-3.618 2.079l1.8.75c.385-.75 1.101-.996 1.853-.996 1.049 0 2.115.63 2.133 1.748v.14c-.368-.21-1.154-.524-2.115-.524-1.941 0-3.916 1.066-3.916 3.057 0 1.818 1.591 2.989 3.373 2.989 1.364 0 2.116-.612 2.588-1.329h.07v1.048h1.957v-5.207c0-2.41-1.8-3.756-4.125-3.756m-12.533 1.95h-2.885v-4.656h2.885c1.516 0 2.377 1.255 2.377 2.327 0 1.053-.861 2.329-2.377 2.329m-.053-6.546h-4.859v13.581h2.027V27.72h2.832c2.248 0 4.458-1.628 4.458-4.219 0-2.59-2.21-4.217-4.458-4.217m-26.498 12.04c-1.401 0-2.574-1.172-2.574-2.782 0-1.627 1.173-2.818 2.574-2.818 1.383 0 2.468 1.19 2.468 2.818 0 1.61-1.085 2.783-2.468 2.783m2.329-6.387h-.07c-.456-.543-1.331-1.033-2.434-1.033-2.312 0-4.43 2.03-4.43 4.638 0 2.59 2.118 4.604 4.43 4.604 1.103 0 1.978-.49 2.433-1.051h.07v.666c0 1.768-.945 2.713-2.468 2.713-1.244 0-2.015-.893-2.33-1.646l-1.768.735c.508 1.226 1.856 2.73 4.097 2.73 2.382 0 4.396-1.4 4.396-4.812v-8.297h-1.926zm3.327 7.928h2.031V19.282h-2.031zm5.024-4.48c-.052-1.785 1.384-2.696 2.416-2.696.807 0 1.49.402 1.717.98zm6.304-1.54c-.385-1.033-1.558-2.94-3.957-2.94-2.381 0-4.36 1.871-4.36 4.62 0 2.59 1.961 4.62 4.587 4.62 2.12 0 3.345-1.294 3.853-2.047l-1.576-1.05c-.525.77-1.243 1.277-2.277 1.277-1.032 0-1.768-.473-2.241-1.4l6.181-2.556zM52.028 25.32v1.96h4.691c-.14 1.103-.507 1.908-1.067 2.467-.683.684-1.752 1.437-3.624 1.437-2.89 0-5.149-2.329-5.149-5.216 0-2.89 2.259-5.216 5.149-5.216 1.558 0 2.696.613 3.536 1.4l1.384-1.383c-1.174-1.12-2.731-1.978-4.92-1.978-3.958 0-7.285 3.221-7.285 7.177s3.327 7.176 7.285 7.176c2.135 0 3.746-.701 5.007-2.014 1.296-1.295 1.699-3.114 1.699-4.585 0-.456-.035-.875-.106-1.225zm12.04 6.003c-1.4 0-2.609-1.155-2.609-2.8 0-1.663 1.209-2.8 2.61-2.8s2.608 1.137 2.608 2.8c0 1.645-1.208 2.8-2.608 2.8m0-7.42c-2.556 0-4.64 1.942-4.64 4.62 0 2.66 2.084 4.62 4.64 4.62 2.557 0 4.64-1.96 4.64-4.62 0-2.678-2.083-4.62-4.64-4.62m10.123 7.42c-1.401 0-2.61-1.155-2.61-2.8 0-1.663 1.209-2.8 2.61-2.8s2.608 1.137 2.608 2.8c0 1.645-1.207 2.8-2.608 2.8m0-7.42c-2.556 0-4.64 1.942-4.64 4.62 0 2.66 2.084 4.62 4.64 4.62s4.64-1.96 4.64-4.62c0-2.678-2.084-4.62-4.64-4.62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M22.654 21.374 11.082 33.65l.002.007a3.124 3.124 0 0 0 4.605 1.884l.036-.022 13.025-7.512z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "m34.36 19.284-.01-.008-5.624-3.258-6.335 5.636 6.358 6.353 5.593-3.226a3.13 3.13 0 0 0 1.646-2.754 3.12 3.12 0 0 0-1.628-2.743"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M11.081 10.35q-.106.386-.106.804v21.694q.001.418.107.803l11.969-11.963z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "m22.739 22 5.989-5.984-13.01-7.54a3.13 3.13 0 0 0-4.636 1.87v.004z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "509a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h147v44H0z"
  })))));
});
const SvgGooglePlayLogo = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGooglePlayLogo);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "bb9f8a54803b2f91ee393132ed38907b.svg";